<template>
  <div>
    <Mainl  :activeName="activeTab"></Mainl>
    <div class="page_content">
      <div class="creative_detail_breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item><a href="/goods" style="color: rgba(19,20,28,0.6);font-weight: 500;">创意中心</a></el-breadcrumb-item>
          <el-breadcrumb-item><a href="#" style="color: rgba(19,20,28,0.9);font-weight: 700;">创意详情</a></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="creative_detail_content">
        <div class="creative_detail_content_left">
              <el-image
                class="creative_detail_img"
                :src="detailshow.GoodsPics"
                :preview-src-list="[detailshow.GoodsPics]"
              >
              </el-image>
        </div>
        <div class="creative_detail_content_right">
          <div class="creative_detail_title">{{detailshow.GoodsName?detailshow.GoodsName:"--"}}</div>
          <div  class="creative_detail_info">
            <span  class="creative_detail_label">创意类目：</span>
            <div  class="creative_detail_value">
              {{detailshow.CategoryVal?detailshow.CategoryVal:"--"}}
            </div>
          </div>
          <div  class="creative_detail_info">
            <span  class="creative_detail_label">描述：</span>
            <span class="creative_detail_value creative_detail_value_p" v-html="formatContent"></span>
          </div>
          <div  class="creative_detail_info creative_detail_info_num">
            <span  class="creative_detail_label">数量：</span>
            <el-input-number  v-model="goods_num" controls-position="right" @change="handleChange" :min="1" :max="999"></el-input-number>
          </div>
          <div class="creative_detail_operate">
            <el-popover  trigger="hover" popper-class="tooltip_class">
              <div  class="header_user_service_tooltip">
                <img :src="require('@/assets/img/qrcode.png')" />
                <p>您可以扫描二维码
                  添加企业微信联系客服</p>
              </div>
              <div slot="reference" class="creative_detail_operate_service">
                <img :src="require('@/assets/img/icon_service_normal.png')" />联系客服
              </div>
            </el-popover>
            <el-button type="primary" @click="cartAdd()" plain class="creative_detail_create_cart">加入购物车</el-button>
            <Placeorder :detailshow = "detailshow"  @numUpdated="updateNum" :defaultNum="goods_num"></Placeorder>
          </div>
        </div>
      </div>
      <div class="case_card_wrap" v-if="caseList.length>0" >
        <div class="case_card_list_title">相关案例</div>
        <div class="case_card_list">
          <div v-for="(v,key) in caseList"  @click="detail(v.case_id)"  :key="key" class="case_card_list_item">
            <img :src="v.annex_url"/>
            <div class="case_card_list_item_content">
              <span>{{v.name}}<img v-if="case_white_id.length > 0 && in_array(v.create_uid, case_white_id)" :src="require('@/assets/img/preferred_case_flag.png')" alt="" style="width: 17px;position: relative; top: 2px; left: 5px;"></span>
              <span :style="case_white_id.length > 0 && in_array(v.create_uid, case_white_id) ? 'font-weight: 600; color: black' : ''">{{v.company}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
/* eslint-disable */
import Mainl from '@/components/Mainl.vue'
import Placeorder from '@/components/Placeorder.vue'
import * as commfun from "@/common/common.js"
export default {
  name: 'Index',
  components: {
    Mainl,
    Placeorder,
  },
  data: function () {
    return {
      activeTab:"1",
      detailshow:{
        GoodsPics:"",
      },//商品详情
      goodsDesc:"",//商品描述
      visibleattr:false,
      srcList:[],//大图
      goods_num:1,//商品数量 默认为1
      goods_id:"",//商品ID
      caseList:[],
      case_white_id: []
    };
  },

  mounted() {
    this.initDetail()
  },
  computed: {
    formatContent() {
      var selfthis=this
      return selfthis.goodsDesc.replace(/\n/g, '<br>');
    }
  },
  methods: {
    //详情界面跳转
    detail(id){
      var url = "casedetail?id="+id + '&jump_from=3';
      window.open(url);
    },
    updateNum(newValue) {
      this.goods_num = newValue;
    },
    initDetail:function (){
      var selfthis=this
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var id = urlParams.get('id');
      var url = "/api/api/goods/getOne"
      commfun.ajaxPost(selfthis,url,{goods_id:id},function (selfthis,data){
        console.log(data)
        selfthis.detailshow = data
        selfthis.detailshow.GoodsPics=require('@/assets/img/goods/'+data.CategoryKey+'/'+data.GoodsPics);
        selfthis.goodsDesc = data.Desc
        selfthis.srcList = []
        //查询成功 查询是否有相关案例
        selfthis.initCase(data.CategoryKey,data.GoodsName)
      },function (selfthis,dataError){
        commfun.showMessage(selfthis,'warning',"错误："+dataError.msg)
      })
    },
    initCase:function (CategoryKey,GoodsName){
      var selfthis=this
      var url = "/api/api/case/relatedCase"
      commfun.ajaxPost(selfthis,url,{category_key:CategoryKey,goods_name:GoodsName},function (selfthis,data){
        selfthis.caseList = data.data
        selfthis.case_white_id = data.case_white_id
      },function (selfthis,dataError){
        commfun.showMessage(selfthis,'warning',"错误："+dataError.msg)
      })
    },
    cartAdd() {
      var selfthis = this
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      selfthis.goods_id= urlParams.get('id');
      var url = "/api/api/shopping_cart/add"
      var data={
        goods_num:selfthis.goods_num,
        goods_id:selfthis.goods_id
      }
      commfun.ajaxPost(selfthis,url,data,function (selfthis,data){
        selfthis.$message({
          type:'success',
          message:'加入购物车成功'
        });
      },function (selfthis,dataError){
        commfun.showMessage(selfthis,'warning',"错误："+dataError.msg)
      })
    },
    mlogin_clean: function (){
      this.visibleattr = false
    },
    mloginaa: function (type){
      this.visibleattr = true
    },
    mlogin: function (type){
    },
    scrollTo: function (type){ //滚动到位置 锚点
      document.querySelector('#'+type).scrollIntoView(true)
    },
    handleChange(value) {
      var selfthis = this
      selfthis.goods_num = value
      // console.log(value);
    },
    // 判断指定值是否在指定数组中
    in_array (search, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] === search) {
          return true;
        }
      }
      return false;
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/components/Detail.vue